export function getAriaDescribedBy(ids) {
  const filtered = ids.filter((id) => !!id);
  return filtered.length > 0 ? filtered.join(' ') : undefined;
}
